import { usePaymentsFeatureFlags } from './usePaymentsFeatureFlags';

/**
 * Hook to check if paymentsMVP feature is enabled.
 *
 * When PAYMENTS_ONBOARDING_ENABLED=true, this flag comes from the payments onboarding service.
 * When PAYMENTS_ONBOARDING_ENABLED=false (default), it comes from LaunchDarkly.
 *
 * @returns {boolean} Whether paymentsMVP is enabled
 */
const usePaymentsMVPEnabled = (): boolean => {
	const { isPaymentsMVPEnabled } = usePaymentsFeatureFlags();
	return isPaymentsMVPEnabled === true;
};

export default usePaymentsMVPEnabled;
